import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>The Strategic Imperative of Investing in <span>Startup Prototype Development</span> for Your Business</h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                       <p>Prioritize Startup Prototype Development for strategic success. Beyond fashioning models, it's a roadmap to success.</p>
                       <p>Our services guarantee accurate translation of concepts, adapting to market changes. Prototypes are vital for investor arenas, market validation, and refining ideas.</p>
                       <p>With a strategic emphasis on validation and industry-specific solutions, we enhance your business potential. Invest wisely—work with us for a journey where prototypes are catalysts, launching your business toward sustainable growth.</p>
                    </Col>
                </Row>
                <Row className="h-100 buss-padd">
                <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Strategic Roadmap</h6>
                            <p>Prioritize Startup Prototype Development as a calculated move, creating a roadmap to success.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Precision Prototypes</h6>
                            <p> Our services pledge accuracy, decoding your ideas into touchable models with thorough attention to detail.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Market Validation</h6>
                            <p>We focus prime validation, guaranteeing that your prototypes align impeccably with market requirements.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Industry-Specific Solutions</h6>
                            <p>Modifying our services to your industry, we offer solutions that go over generic models.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Practical Investment</h6>
                            <p>Our Startup Prototype Development is more than creating; it's about catalyzing your business towards supportable growth.</p>
                        </div>
                    </div>
                </Col>
    
                </Row>
            </Container>
    </div>
  )
}

export default Androidbuss